// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';


// Stateless components

export function EmailLink(props) {

    //
    // Sub components
    //

    function RenderLink(context) {
        var unread_emails_count = context['unread_emails_count'];
        var count_class = 'count--single';

        if(unread_emails_count > 99) {
            unread_emails_count = 99;
        }

        if(unread_emails_count > 9) {
            count_class = 'count--double';
        }

        return (
            <div className="email-link__wrapper">
                <span className="email-link__label">Email</span>
                {unread_emails_count > 0 && 
                <span className={"email-link__count " + count_class}>{unread_emails_count}</span>
                }
            </div>
        );
    }


    //
    // Render
    //

    return (
        <PortalContext.Consumer>
            {RenderLink}
        </PortalContext.Consumer>
    );

};
